import { useMemo } from 'react';
import { getInitialSendersFromChannelInstance } from '../operators/getInitialSendersFromChannelInstance';
import { useSendFromChannelInstance } from '../../_internal/hooks/useSendFromChannelInstance';
export const useInitialSenders = ({
  inboxId,
  inReplyToMessage,
  channelId,
  userId
}) => {
  const shouldDefer = !inboxId || !channelId;
  const {
    channelInstanceToSendFrom,
    isLoading
  } = useSendFromChannelInstance({
    channelId,
    deferred: shouldDefer,
    inboxId,
    inReplyToMessage
  });
  const areSendersLoading = !shouldDefer && isLoading;
  const senders = useMemo(() => {
    const senderListFromChannelInstance = getInitialSendersFromChannelInstance({
      channelId,
      channelInstance: channelInstanceToSendFrom,
      userId
    });
    return senderListFromChannelInstance;
  }, [channelId, channelInstanceToSendFrom, userId]);
  return {
    senders,
    areSendersLoading
  };
};